import HP_SectionOne from "./HP_SectionOne";

function HeadersProducts() {
  return (
    <>
      <main>
        <HP_SectionOne />
      </main>
    </>
  );
}

export default HeadersProducts;
